import { gql } from '__generated__';

export default gql(`
  mutation AddMailPermission($input: AddMailPermissionInput!) {
    addMailPermission(input: $input) {
      id
      title
      label
    }
  }
`);
